import React from 'react';
import { withRouter } from 'react-router-dom';

class VisualizarTipoConta extends React.Component {

    constructor() {

        super();

        this.state = {
            centro: "",
            centroId: 0,
            id: "",
            codConta: "",
            tipoConta: "",
            cor: "",
            categoria: "",
            categoriaId: "",
            corrente: ""
        };

        this.editar = this.editar.bind(this);
        this.voltar = this.voltar.bind(this);

    }

    formatarCorrente(c) {
        if (c) return "Sim";
        else return "Não";
    }

    editar() {

        let obj = {
            id: this.state.id,
            codConta: this.state.codConta,
            tipoConta: this.state.tipoConta,
            cor: this.state.cor,
            categoria: this.state.categoria,
            categoriaId: this.state.categoriaId,
            corrente: this.state.corrente,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/editartipoconta",
            state: obj
        });

    }

    voltar() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/tiposconta",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let id = this.props.location.state.row.id;
        let tipoConta = this.props.location.state.row.data[0];
        let codConta = this.props.location.state.row.data[1];

        this.setState({ id: id });
        this.setState({ tipoConta: tipoConta });
        this.setState({ codConta: codConta });

        fetch("/api/centro/centrotipoconta/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centro: responseJson.nome });
            this.setState({ centroId: responseJson.id });

            fetch("/api/tipo_conta/" + id, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ cor: responseJson2.cor });
                this.setState({ corrente: responseJson2.corrente });

                if (responseJson2.categoria !== null) {

                    this.setState({ categoriaId: responseJson2.categoria });
                    this.setState({ categoria: responseJson2.categoria_nome });

                }

            });

        });

    }

    render() {
        return(
            <div>
                <h1 id="visualizar-tipoconta-title">Tipo de Conta</h1><br /><br />
                <p id="visualizar-tipoconta-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <table id="visualizar-tipoconta-table">
                    <tbody>
                        <tr>
                            <td><b>Código:</b></td>
                            <td>{ this.state.codConta }</td>
                        </tr>
                        <tr>
                            <td><b>Tipo de Conta:</b></td>
                            <td>{ this.state.tipoConta }</td>
                        </tr>
                        <tr>
                            <td><b>Cor:</b></td>
                            <td>
                                <center>
                                    <div Style={ "background: " + this.state.cor
                                        + "; width: 60px; height: 15px;" }></div>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td><b>Categoria:</b></td>
                            <td>{ this.state.categoria }</td>
                        </tr>
                        <tr>
                            <td><b>Corrente:</b></td>
                            <td>{ this.formatarCorrente(this.state.corrente) }</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <button Class="visualizar-tipoconta-btn"
                    id="visualizar-tipoconta-voltar-btn"
                    onClick={ this.voltar }>Voltar</button>
                { localStorage.roleContas === "escrever" &&
                    <button Class="visualizar-tipoconta-btn"
                        id="visualizar-tipoconta-editar-btn"
                        onClick={ this.editar }>Editar</button> }
                <br /><br />
            </div>
        );
    }

}

export default withRouter(VisualizarTipoConta);

